"use client";

import { PrismicNextLink } from "@prismicio/next";
import Dropdown from "./Dropdown";

/**
 * @typedef {import("@prismicio/client").Content.FooterLinkListSlice} FooterLinkListSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<FooterLinkListSlice>} FooterLinkListProps
 * @param {FooterLinkListProps}
 */
const FooterLinkList = ({ slice }) => {
  const topPosition = slice?.primary?.is_dropdown_at_top_position;
  return (
    <div>
      <div className="mb-[12px] xl:mb-[40px] md:mb-[24px]">
        <h2 className="text-[white] title-font title-small">
          {slice?.primary?.title}
        </h2>
      </div>
      <ul>
        {/* Render Dropdown only if is_dropdown_at_top_position is true */}
        {topPosition && slice?.primary?.dropdown_menu_label && (
          <Dropdown slice={slice} topPosition={topPosition} />
        )}

        {slice?.primary?.links?.map((item, idx) => {
          // if (idx < 6) {
          return (
            <li className="text-base mb-[8px] md:mb-[16px] last:mb-0" key={idx}>
              <PrismicNextLink
                className="duration-200 text-[#C4C4C8] footer-text-hover"
                field={item?.link}
              >
                {item?.label}
              </PrismicNextLink>
            </li>
          );
          // }
        })}
        {/* {slice?.primary?.links?.length > 6 && (
          <ViewAll slice={slice} threshold={7} />
        )} */}

        {/* Render Dropdown only if is_dropdown_at_top_position is false */}
        {!topPosition && slice?.primary?.dropdown_menu_label && (
          <Dropdown slice={slice} topPosition={topPosition} />
        )}
      </ul>
    </div>
  );
};

export default FooterLinkList;
